export const UserTypes = {
	FREELANCE: 0,
	STUDIO: 1,
	CUSTOMER: 2,
};
